// lazyPanel — load a rarely-used panel/modal on demand instead of in the main bundle.
//   const ThreadPanel = lazyPanel(() => import("../components/ThreadPanel.jsx"));
// Used exactly like the component it wraps (own Suspense boundary, renders nothing while loading — these are
// all overlays that appear on a click). Every registered loader is prefetched once the app is idle, so in
// practice the code is already there by the time someone opens the panel.
// After a deploy the old chunk files are gone; a tab still running the old bundle would fail to load one.
// Instead of crashing, reload once to pick up the new version (guarded so it can't loop).
import { lazy, Suspense } from "react";

const loaders = [];
const RELOAD_KEY = "tmc.chunkReload";

function guarded(loader) {
  return () => loader().catch((err) => {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last > 60000) {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
    throw err;
  });
}

export function lazyPanel(loader) {
  const load = guarded(loader);
  loaders.push(load);
  const Lazy = lazy(load);
  function LazyPanel(props) {
    return <Suspense fallback={null}><Lazy {...props} /></Suspense>;
  }
  return LazyPanel;
}

/** Fetch every registered panel in the background once the browser is idle (after first paint). */
export function prefetchPanels() {
  const run = () => loaders.forEach((l) => { l().catch(() => {}); });
  if ("requestIdleCallback" in window) window.requestIdleCallback(run, { timeout: 8000 });
  else setTimeout(run, 3000);
}
